import React, { ReactElement } from 'react';

export function FooterText({ children }: { children: React.ReactNode }): ReactElement {
  return (
    <p className="color-gray-800" style={{ fontSize: '14px' }}>
      {children}
    </p>
  );
}
